import { FunctionComponent } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import { BuySharedFAQAuthor_author } from './__generated__/BuySharedFAQAuthor_author.graphql';
import Logo2020 from 'dibs-icons/exports/Logo2020';
import styles from './BuySharedFAQAuthor.scss';

export type Props = {
    author: BuySharedFAQAuthor_author | null;
    formattedCreatedDate?: string | null;
};

export const BuySharedFAQAuthorComponent: FunctionComponent<Props> = ({
    author,
    formattedCreatedDate,
}) => {
    const sellerPreferences = author?.sellerPreferences;
    if (sellerPreferences) {
        const { label: name, scrollLogo: logo, urlLabel } = sellerPreferences;
        if (name) {
            const url = `/dealers/${urlLabel}/`;
            return (
                <div className={styles.author}>
                    {logo && <img className={styles.authorLogo} src={logo} alt={name} />}
                    <div className={styles.authorInfo} data-tn="faq-answer-author">
                        <Link href={url}>{name}</Link>
                        {formattedCreatedDate && <span>{formattedCreatedDate}</span>}
                    </div>
                </div>
            );
        }
    }

    return (
        <div className={styles.author}>
            <Logo2020 className={styles.expertLogo} />
            <div className={styles.authorInfo} data-tn="faq-answer-author">
                <FormattedMessage
                    id="BuySharedFAQ.author.defaultAuthor"
                    defaultMessage="1stDibs Expert"
                />
                {formattedCreatedDate && <span>{formattedCreatedDate}</span>}
            </div>
        </div>
    );
};

export const BuySharedFAQAuthor = createFragmentContainer(BuySharedFAQAuthorComponent, {
    author: graphql`
        fragment BuySharedFAQAuthor_author on Seller {
            sellerPreferences {
                label
                urlLabel
                scrollLogo
            }
        }
    `,
});
